// @tenorlab/vue-dashboard-pro
// file: src/bundled-widgets/widget-bar-gradients/meta.ts
import type { TWidgetMetaInfo } from '@tenorlab/vue-dashboard'
import { FileQuestion as ComponentIcon } from 'lucide-vue-next'

// Define the metadata object for the plugin
export const WidgetBarGradientsMeta: TWidgetMetaInfo = {
  name: 'Bar Gradients Sample',
  categories: ['Widget', 'Chart'],
  icon: ComponentIcon,
  noDuplicatedWidgets: true,
  description: 'Progress bars or bar chart demostrating css gradient colors.',
  externalDependencies: [],
}
